exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.range-container[data-v-5915d43e] {\n  padding: 1rem 0;\n  margin: 0.7rem 0.3rem;\n  background-color: #f7f7f7;\n}\nh2[data-v-5915d43e] {\n  text-align: center;\n  font-size: 1.2rem;\n}\nh2 span[data-v-5915d43e] {\n  padding: 0 1rem;\n}\n.selected-color[data-v-5915d43e] {\n  height: 2rem;\n  width: 2rem;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5915d43e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/range.vue
// module id = 1317
// module chunks = 2